import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PreviewLaudos } from 'vivace-fluent-motion';
import * as commonActions from '@common/common.action';
import LaudoApi from '../laudo.api';
import { injectIntl } from 'react-intl';

function Preview({ laudoId, etapa, show, setShow, stringRtf, intl }) {
  const dispatch = useDispatch();
  const [previewLaudoPdf, setPreviewLaudoPdf] = useState();
  const [preview, setPreview] = useState(false);
  const [laudoIdselecionado, setLaudoIdselecionado] = useState(0);
  const [etapaSelecionada, setEtapaSelecionada] = useState('');
  const { messages } = intl;

  useEffect(() => {
    if (stringRtf) {
      show && showPreviewByRtf(laudoId, etapa, stringRtf);
    } else {
      setLaudoIdselecionado(laudoId);
      setEtapaSelecionada(etapa);
      show && showPreview(laudoId, etapa);
    }
  }, [laudoId, etapa, show]);

  const showPreview = (laudoId, etapa) => {
    if (
      laudoId !== laudoIdselecionado ||
      etapa !== etapaSelecionada ||
      !previewLaudoPdf
    ) {
      setPreviewLaudoPdf('');
      dispatch(commonActions.showFadeCarregando(true));
      LaudoApi.obterBasePdf64String(laudoId, etapa).then(res => success(res));
    } else {
      setPreview(true);
    }
  };

  const showPreviewByRtf = (laudoId, etapa, stringRtf) => {
    setPreviewLaudoPdf('');
    dispatch(commonActions.showFadeCarregando(true));
    LaudoApi.obterBasePdf64StringByRtf(laudoId, etapa, stringRtf).then(res =>
      success(res)
    );
  };

  const success = res => {
    dispatch(commonActions.showFadeCarregando(false));
    setPreview(true);
    setPreviewLaudoPdf(`data:application/pdf;base64,${res}`);
  };

  return (
    <div style={{ display: preview ? 'initial' : 'none' }}>
      {previewLaudoPdf && (
        <PreviewLaudos
          messageTitle={messages['dashboards.reports.printPreview']}
          printLabel={messages["dashboards.reports.printOut"]}
          saveLabel={messages["general.requestsPanel.save"]}
          messageLoader={messages['message.loading']}
          messageErroFile={messages['messages.noChargeReport']}
          visible={preview}
          IdExamePedido={laudoId}
          allowcors={false}
          file={previewLaudoPdf}
          onOpened={() => {
            setPreview(false);
            setShow && setShow(false);
          }}
        />
      )}
    </div>
  );
}

export default injectIntl(Preview);


// WEBPACK FOOTER //
// ./src/pages/laudo/Preview/index.js